<template>
  <div class="container-fluid">
    <el-alert v-if="status===200"
        title="SKU успешно удалена."
        type="success"
        effect="dark">
    </el-alert>
      <el-row :span="24" type="flex" justify="space-between">
        <el-col :span="4">
          <h4>Предложение</h4>
        </el-col>
        <!-- <el-col :span="4">
          <el-button type="success" disabled @click="$store.commit('skuCreateDialog',true)">Добавить предложение</el-button>
        </el-col> -->
      </el-row>
      <el-table class="p-2"
          :data="getItem"
          style="width: 100%"
          empty-text="Нет данных">
        <!-- <el-table-column
            prop="id"
            label="Id"
            width="50">
        </el-table-column> -->
        <el-table-column type="expand">
          <template>
              <el-table class="p-2"
              :data="getItems"
              style="width: 100%"
              >
                <el-table-column
                prop="id"
                label="Id"
                />
                <el-table-column
                prop="title"
                label="Магазин"
                />                
                <el-table-column
                prop="quantity"
                label="Количество"
                />
              </el-table>
          </template>
        </el-table-column>
        <el-table-column
            label="Цены"
            >
          <template>
            <div v-if="getPrices.length > 0">
              <p v-for="attr in getPrices" :key="attr.id">
                <span>{{attr.title}}</span> : <span>{{attr.price}} р.</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            label="Характеристики"
           >
          <template>
            <div v-if="getOptions.length > 0">
              <p v-for="attr in getOptions" :key="attr.id">
                <span>{{attr.title}}</span> : <span>{{attr.value}}</span>
              </p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="quantity"
            label="Количество"
        >
        </el-table-column> -->
          <!-- <el-table-column
            prop="sort"
            label="Сортировка"
          >
          </el-table-column> -->
          <!-- <el-table-column
            prop="activity"
            label="Активность"
          >
              <template slot-scope="scope">
                  <p v-if="!scope.row.activity">Нет</p>
                  <p v-if="scope.row.activity">Да</p>
              </template>
          </el-table-column> -->
          <!-- <el-table-column
                  label="Действия"
                  width="300"
                 >
              <template slot-scope="scope">
                  <el-button v-if="scope.row.activity"
                             size="mini"
                             type="primary"
                             plain
                             @click="hideRow(scope.$index)" disabled>Скрыть</el-button>
                  <el-button v-if="!scope.row.activity"
                             size="mini"
                             type="primary"
                             plain
                             @click="restoreRow(scope.$index)" disabled>Восстановить</el-button>
                  <el-button
                             size="mini"
                             @click="updateRow(scope.$index)" disabled>Изменить</el-button>
                  <el-button
                             size="mini"
                             type="danger"
                             @click.native.prevent="deleteRow(scope.$index)" disabled>Удалить</el-button>
              </template>
          </el-table-column> -->
      </el-table>
    <!-- <create-product-sku-dialog @updateParent="onUpdateSalary"></create-product-sku-dialog>
    <update-product-sku-dialog v-if="$store.getters.skuUpdateDialog" @updateParent2="onUpdateSalary2"></update-product-sku-dialog> -->
  </div>
</template>

<script>
import axios from "axios";
// import CreateProductSkuDialog from "@/components/ProductSkus/CreateProductSkuDialog";
// import UpdateProductSkuDialog from "@/components/ProductSkus/UpdateProductSkuDialog";

export default {
  name: "ProductSkus",
  // components: {UpdateProductSkuDialog, CreateProductSkuDialog},
  props: ['item'],
  data: function (){
    return{
      skus:[],
      status:0
    }
  },
  mounted() {
    // this.getSkusOfProducts();
    // this.status = 0;
  },
  computed: {
    getItem() {
      return [this?.item]
    },
    getItems() {
      return this?.item?.detail_quantity || []
    },
    getPrices() {
      return this?.item?.priceTypes || []
    },
    getOptions() {
      return this?.item?.options || []
    }
  },
  methods:{
    onUpdateSalary(){
      this.getSkusOfProducts();
    },
    onUpdateSalary2(){
      this.getSkusOfProducts();
    },
    getSkusOfProducts(){
      axios.get('/api/admin/product/'+this.$store.getters.productId+'/getSkus').then((response)=>{
        console.log(response.data);
        this.skus = response.data.data;
      }).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
      });
    },
    goToPage: function (path){
      this.$router.push(path);
    },
    deleteRow: function (index) {
      let id = this.skus[index].id;

      axios.delete('/api/admin/productSku/'+id+'/delete').then((response)=>{
        this.status = response.status;
        this.status = 0;
        this.getSkusOfProducts();
      }).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
      });


    },
      hideRow: function (index) {
          let id = this.skus[index].id;

          axios.post('/api/admin/productSku/'+id+'/hide').then((response)=>{
              this.status = response.status;
              this.getSkusOfProducts();
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              }
          });


      },
      restoreRow: function (index) {
          let id = this.skus[index].id;

          axios.post('/api/admin/productSku/'+id+'/restore').then((response)=>{
              this.status = response.status;
              this.getSkusOfProducts();
          }).catch((errors)=>{
              if(errors.response.status === 401){
                  this.$router.push('/login');
              }
          });

      },

    updateRow: function (index) {
      let id = this.skus[index].id;
      this.$store.commit('updateId',id);
      this.$store.commit('skuUpdateDialog',true);


    },
  }
}
</script>

<style scoped>

</style>